import './App.css';
import RoutesComponent from "./Routes/routeComponent"
import { DashboardInfoProvider } from "./Context/dashboardContext";
import { UserProvider } from './Context/userContext';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { InsightsProvider } from './Context/insightContext';
import { ThemeProvider } from "@mui/material";
import muiCustomTheme from "./utils/customMUITheme/customMUITheme";
import { EscalationInfoProvider } from './Context/escalationContext';
import { AgencyInfoProvider } from './Context/agencyContext';
import * as Sentry from "@sentry/react";
import { useEffect } from 'react';
import {
    createRoutesFromChildren,
    matchRoutes,
    useLocation,
    useNavigationType,
} from "react-router-dom";
import { GetEnvVar } from './utils/getEnvironmentCurrent';
function App() {

		if (GetEnvVar() === "stage" || GetEnvVar() === "production") {
		const sentryDsn = process.env["REACT_APP_SENTRY_DSN"];
		let environment = GetEnvVar()
		if (sentryDsn) {
			Sentry.init({
				dsn: sentryDsn,
				environment,
				sendDefaultPii: false,
				// Control transaction volume (0.1 = 10% of page loads/navigations)
				tracesSampleRate: 0.2,
				integrations: [
					Sentry.browserTracingIntegration(),
					Sentry.reactRouterV6BrowserTracingIntegration({
						useEffect,
						useLocation,
						useNavigationType,
						createRoutesFromChildren,
						matchRoutes,
					}),
				],
			});
		}
	} else {
		console.warn("Non prod environment, Sentry NOT initialized");
	}


	return (
		<Sentry.ErrorBoundary fallback={<div style={{ padding: 24, textAlign: "center" }}>Something went wrong. Our team has been notified.</div>}>
		<UserProvider>
			<DashboardInfoProvider>
				<InsightsProvider>
					<EscalationInfoProvider>
						<AgencyInfoProvider>
							<ThemeProvider theme={muiCustomTheme}>
								<RoutesComponent />
								<ToastContainer
									position="bottom-right"
									pauseOnHover={false}
									autoClose={5000}
									closeOnClick={true}
									pauseOnFocusLoss={false}
								/>
							</ThemeProvider>
						</AgencyInfoProvider>
					</EscalationInfoProvider>
				</InsightsProvider>
			</DashboardInfoProvider>
		</UserProvider>
		</Sentry.ErrorBoundary>
	);
}

export default App;
